<template>
  <div>
    <!--Конфигурации приложения + Настройки времени простоя заказов-->
    <admin-configs/>

    <!--Стартовые бонусы для клиентов-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.title_start_bonus }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div>
            {{ local_page_keys.default_start_bonus }}
          </div>
          <div class="uk-width-small">
            <input v-model="defaultBonusValue" class="uk-input" type="text"/>
          </div>
          <div>
            <button type="button" class="uk-button uk-button-success" @click="updateDefaultValue(defaultBonusID, defaultBonusValue)">
              {{ local_page_keys.button_save }}
            </button>
          </div>
        </div>
      </div>
      <div class="uk-card-footer">
        <div v-for="day in days" :key="day" class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div class="uk-width-small">
            {{ day }}
          </div>
          <div>
            <input v-model="startBonusByDate[day]" class="uk-input" type="text"/>
          </div>
        </div>
        <button type="button" class="uk-button uk-button-success uk-margin-medium" @click="updateDefaultValue(startBonusByDateId, startBonusByDate)">
          {{ local_page_keys.button_save }}
        </button>
      </div>
    </div>

    <!--Бонусы для поделившегося ссылкой-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.shared_bonus_title }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div>
            {{ local_page_keys.default_start_bonus }}
          </div>
          <div class="uk-width-small">
            <input v-model="defaultSharedBonus" class="uk-input" type="text"/>
          </div>
          <div>
            <button type="button" class="uk-button uk-button-success" @click="updateDefaultValue(defaultSharedBonusID, defaultSharedBonus)">
              {{ local_page_keys.button_save }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Бонусы для перешедшего по ссылке-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.follower_bonus_title }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div>
            {{ local_page_keys.default_start_bonus }}
          </div>
          <div class="uk-width-small">
            <input v-model="defaultFollowerBonus" class="uk-input" type="text"/>
          </div>
          <div>
            <button type="button" class="uk-button uk-button-success" @click="updateDefaultValue(defaultFollowerBonusID, defaultFollowerBonus)">
              {{ local_page_keys.button_save }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--Тестовый заказ по умолчанию-->
    <div v-if="defaultTestOrder !== null" class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              {{ local_page_keys.default_test_order_label }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-grid-small uk-child-width-1-1 uk-flex-middle" data-uk-grid>
          <div>
            <md-radio v-model="defaultTestOrderValue" value="true">{{ local_page_keys.test_order_yes }}</md-radio>
            <md-radio v-model="defaultTestOrderValue" value="false">{{ local_page_keys.test_order_no }}</md-radio>
          </div>
          <div>
            <button type="button" class="uk-button uk-button-success" @click="updateDefaultValue(defaultTestOrder.id, (defaultTestOrderValue === 'true' ? 1 : 0))">
              {{ local_page_keys.button_save }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--таблица-->
    <div class="uk-card uk-card-default uk-margin">
      <div class="uk-card-header">
        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-expand">
            <div class="uk-card-title uk-margin-remove-top">
              Таблица бонусов
            </div>
          </div>
        </div>
      </div>
      <div class="uk-card-body">
        <div>
          <v-tabs class="tm-tabs" v-model="tab">
            <v-tab v-for="(header, index) of tabHeaders" :key="index" class="uk-text-uppercase">
              {{header}}
            </v-tab>
          </v-tabs>
          <v-tabs-items class="tm-tabs-content" v-model="tab">
            <v-tab-item  v-for="(header, i) of tabHeaders" :key="i">
              <!--Групповое изменение стартового бонуса-->
              <div class="uk-grid uk-grid-small uk-flex-middle uk-margin-top" data-uk-grid>
                <div>
                  {{ local_page_keys.mass_update_bonuses_label }}
                </div>
                <div class="uk-width-small">
                  <div class="uk-inline">
                    <button type="button" class="uk-form-icon uk-form-icon-flip" @click="massUpdateStartBonusesValue = 0" data-uk-tooltip="Очистить поле">
                      <md-icon>clear</md-icon>
                    </button>
                    <input v-model="massUpdateStartBonusesValue" class="uk-input" type="number"/>
                  </div>
                </div>
                <div>
                  <button type="button" class="uk-button uk-button-success" @click="massUpdateStartBonuses">
                    <md-icon>done</md-icon>
                  </button>
                </div>
              </div>

              <!--новая таблица-->
              <div class="uk-margin">
                <!--шапка-->
                <div class="uk-grid uk-grid-collapse uk-flex-middle uk-text-meta uk-text-bold uk-text-center" data-uk-grid>
                  <div class="uk-width-expand">
                    <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-4" data-uk-height-match="target: > div > .uk-padding-xsmall" data-uk-grid>
                      <div>
                        <div class="uk-padding-xsmall">
                          {{ local_page_keys.table_name_county }}
                        </div>
                      </div>
                      <div>
                        <div class="uk-padding-xsmall">
                          {{ local_page_keys.table_code_country }}
                        </div>
                      </div>
                      <div>
                        <div class="uk-padding-xsmall">
                          {{ local_page_keys.table_start_bonus }}
                          <a class="uk-display-inline-block uk-li2nk-reset"  data-uk-tooltip="title: Сортировка по бонусу">
                        <span class="uk-icon" @click="sort('start_bonuses')">
                          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <polygon points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon>
                            <line fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line>
                          </svg>
                        </span>
                            <span class="uk-icon uk-link-reset" style="margin-left: -6px;" @click="sort('start_bonuses')">
                          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <polygon points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon>
                            <line fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line>
                          </svg>
                        </span>
                          </a>
                        </div>
                      </div>
                      <div>
                        <div class="uk-padding-xsmall">
                          {{ local_page_keys.test_order_label }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="width: 80px;">

                  </div>
                </div>

                <hr class="uk-margin-small">
                <!--строки-->
                <div class="uk-grid uk-grid-collapse uk-child-width-1-1 uk-grid-divider" data-uk-grid>
                  <div v-for="(item, index) of tabDataCity[i]" :key="item.id">
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-text-small" data-uk-grid>
                      <div class="uk-width-expand">
                        <div class="uk-grid uk-grid-collapse uk-flex-middle tm-grid-bg-hover uk-child-width-1-4" data-uk-grid>
                          <!--страна-->
                          <div class="uk-text-center">
                            <div class="uk-padding-xsmall">
                              {{ item.name }}
                            </div>
                          </div>
                          <!--код страна-->
                          <div class="uk-text-center">
                            <div class="uk-padding-xsmall">
                              {{ item.code }}
                            </div>
                          </div>
                          <!--бонусы-->
                          <div>
                            <div class="uk-padding-xsmall uk-text-center">
                              <div class="uk-grid uk-grid-collapse uk-flex-middle uk-flex-center" data-uk-grid>
                                <div class="uk-width-expand">
                                  <div class="uk-inline uk-width-small">
                                    <button v-if="showDeleteButton(i,index)"
                                            type="button"
                                            class="uk-form-icon uk-form-icon-flip"
                                            @click="deleteCountryCredits(tabDataCity[i][index].id )"
                                            data-uk-tooltip="title: Очистить поле; offset: 5">
                                      <md-icon>clear</md-icon>
                                    </button>
                                    <input v-model="tabDataCity[i][index].start_bonuses"
                                           class="uk-input"
                                           name="text"
                                           :id="'Input_'+tabDataCity[i][index].id"
                                           @input="prepareUpdateList(index, 'input')">
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--тестовый заказ-->
                          <div>
                            <div class="uk-text-center">
                              <md-radio v-model="tabDataCity[i][index].test_order" value="true" @change="prepareUpdateList(index, 'radio')">{{ local_page_keys.test_order_yes }}</md-radio>
                              <md-radio v-model="tabDataCity[i][index].test_order" value="false" @change="prepareUpdateList(index, 'radio')">{{ local_page_keys.test_order_no }}</md-radio>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--кнопка-->
                      <div style="width: 80px;">
                        <div class="uk-padding-xsmall uk-text-center">
                          <button type="button"
                                  class="uk-button uk-button-small uk-button-success md-success"
                                  @click="updateCountryCredits(tabDataCity[i][index].id, (tabDataCity[i][index].test_order === 'true' ? true : false))"
                                  data-uk-tooltip="title: Сохранить настройка страны; offset: 5">
                            <md-icon>done</md-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!--старая таблица-->
<!--              <div class="uk-margin">-->
<!--                <md-table v-model="tabDataCity[i]" table-header-color="green" md-sort="start_bonuses" md-sort-order="asc">-->
<!--                  <md-table-row slot="md-table-row" slot-scope="{ index }">-->
<!--                    <md-table-cell :md-label="local_page_keys.table_name_county">{{ tabDataCity[i][index].name   }}</md-table-cell>-->
<!--                    <md-table-cell :md-label="local_page_keys.table_code_country">{{  tabDataCity[i][index].code   }}</md-table-cell>-->
<!--                    <md-table-cell md-sort-by="start_bonuses" :md-label="local_page_keys.table_start_bonus">-->
<!--                      <input v-model="tabDataCity[i][index].start_bonuses" style="width:100%" name="text"  :id="'Input_'+tabDataCity[i][index].id" @input="prepareUpdateList(index, 'input')">-->
<!--                    </md-table-cell>-->
<!--                    <md-table-cell :md-label="local_page_keys.test_order_label">-->
<!--                      <md-radio v-model="tabDataCity[i][index].test_order" value="true" @change="prepareUpdateList(index, 'radio')">{{ local_page_keys.test_order_yes }}</md-radio>-->
<!--                      <md-radio v-model="tabDataCity[i][index].test_order" value="false" @change="prepareUpdateList(index, 'radio')">{{ local_page_keys.test_order_no }}</md-radio>-->
<!--                    </md-table-cell>-->
<!--                    <md-table-cell>-->
<!--                      <md-button type="button" class="uk-button uk-button-small uk-button-success md-success" style="margin: 2%" @click="updateCountryCredits(tabDataCity[i][index].id, (tabDataCity[i][index].test_order === 'true' ? true : false))">-->
<!--                        <md-icon>done</md-icon>-->
<!--                      </md-button>-->
<!--                      <md-button v-if="showDeleteButton(i,index)" type="button" class="uk-button uk-button-small uk-button-danger md-danger" style="margin: 2%" @click="deleteCountryCredits(tabDataCity[i][index].id )">-->
<!--                        <md-icon>delete</md-icon>-->
<!--                      </md-button>-->
<!--                    </md-table-cell>-->
<!--                  </md-table-row>-->
<!--                </md-table>-->
<!--              </div>-->

            </v-tab-item>
          </v-tabs-items>
        </div>
        <div v-if="makeVisibleButton" class="uk-margin">
          <button type="button" class="uk-button uk-button-success" @click="updateAll()">
            {{ local_page_keys.button_save }}
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import AdminConfigs from "@/pages/Dashboard/Pages/AdminConfigs";
export default {
  name: "StartBonusClient",
  components: { AdminConfigs},

  data() {
    return {
      defaultBonusSettings: null,
      defaultTestOrder: null,
      listCountry: {},
      local_page_keys: {},
      defaultBonusValue: '',
      defaultTestOrderValue: '',
      defaultBonusID: '',
      defaultSharedBonus: '',
      defaultSharedBonusID: '',
      defaultFollowerBonus: '',
      defaultFollowerBonusID: '',
      addNewCountry: '',
      countryCredits: '',
      listCountryCredits: {},
      startBonusByDate: {},
      startBonusByDateId: '',
      testOrder: 'false',
      updatedList: [],
      makeVisibleButton: false,
      radioChanged: false,
      updatedId: '',
      wasUpdated: false,
      days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      filterBonus: 1,
      tabHeaders: {},
      tab: null,
      tabDataCity: [[], []],
      massUpdateStartBonusesValue:0,
      sortField: 'start_bonuses',
      sortDirection: 'asc',
    };
  },

  methods: {
    async getListCountry() {
      await this.$store.dispatch('startBonus/listCountry');
      let listCountry = await this.$store.getters['startBonus/listCountry'];
      this.listCountry = this.getDefaultListCountry(listCountry);
    },
    async getDefaultBonusSettings() {
      await this.$store.dispatch('startBonus/defaultBonusSettings');
      this.defaultBonusSettings = await this.$store.getters['startBonus/defaultBonusSettings'];

      for (let setting of this.defaultBonusSettings) {

        switch (setting.name_const) {
          case "default_client_credit_start_bonus":
            this.defaultBonusValue = setting.value;
            this.defaultBonusID = setting.id;
            break;
          case "shared_bonus":
            this.defaultSharedBonus = setting.value;
            this.defaultSharedBonusID = setting.id;
            break;
          case "follower_bonus":
            this.defaultFollowerBonus = setting.value;
            this.defaultFollowerBonusID = setting.id;
            break;
          case "default_to_give_test_order":
            this.defaultTestOrder = setting;
            this.defaultTestOrderValue = setting.value == true ? 'true' : 'false';
            break;
          case "start_bonus_by_day":
            this.startBonusByDate = JSON.parse(setting.value);
            this.startBonusByDateId = setting.id;
            break;
          default:
            break;
        }
      }
    },
    sort(field) {
      if (field === this.sortField) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }
      const direction = this.sortDirection === 'asc' ? 1 : -1;
      this.tabDataCity[this.tab].sort((a, b) => (a[this.sortField] - b[this.sortField]) * direction);
    },
    async updateDefaultValue(id, value) {
      //console.log(value, value === '', value === null, value === undefined);
      if (value === '' || value === null || value === undefined) {
        alert(this.local_page_keys.alert_fill_in_the_field + '!');
      } else {
        await this.$store.dispatch('startBonus/updateDefaultSetting', {id, value});
        this.getListCountryCredits();
        alert(this.local_page_keys.alert_update + '!');
      }
    },
    async submitTestOrder() {
      let country_id = this.addNewCountry;
      let test_order = this.testOrder;
      await this.$store.dispatch('startBonus/testorderupdate', {country_id, test_order});
      let testOrder = await this.$store.getters['startBonus/testorderupdate'];
      if (testOrder.success === true){
        this.getListCountryCredits();
        this.addNewCountry = '';
        alert(this.local_page_keys.alert_update+'!');
      }
    },
    async getTestOrderInfo(){
      let country_id = this.addNewCountry;
      await this.$store.dispatch('startBonus/testorderinfo', {country_id});
      let testOrder = await this.$store.getters['startBonus/testorderinfo'];
      this.testOrder = testOrder.test_order;
      this.countryCredits = testOrder.start_bonuses;
      this.getListCountryCredits();
    },
    async addCountry() {
      if(this.countryCredits === '' || this.addNewCountry === ''){
        alert(this.local_page_keys.alert_fill_in_the_field+'!')
      }else {
        await this.$store.dispatch('startBonus/addNewCountryCredits', {id_country: this.addNewCountry, count_credits:this.countryCredits});
        let listContries = await this.$store.getters['startBonus/addNewCountryCredits'];
        this.listCountryCredits = this.getNotDefaultCountries(listContries);
        this.addNewCountry = '';
        this.listCountry = this.getDefaultListCountry(listContries);
      }
    },
    async getListCountryCredits() {
      await this.$store.dispatch('startBonus/listCountryCredits');
      let listContries = await this.$store.getters['startBonus/listCountryCredits'];
      this.listCountryCredits = this.getNotDefaultCountries(listContries);
      this.listCountry = this.getDefaultListCountry(listContries);
    },
    getNotDefaultCountries(list) {
      let notDefaultList = [];
      for (let item in list) {
        if (list[item].start_bonuses != this.defaultBonusValue || list[item].test_order != this.defaultTestOrderValue) {
          notDefaultList.push(list[item])
        }
      }
      return notDefaultList;
    },
    async updateCountryCredits(id, test_order){
      let count = document.querySelector('#Input_'+id).value;
      if(count === '' && !this.radioChanged){
        alert(this.local_page_keys.alert_fill_in_the_field+'!')
      } else {
        await this.$store.dispatch('startBonus/addNewCountryCredits', {id_country: id, count_credits:count, test_order});
        this.updatedId = id;
        this.wasUpdated = true;
        alert(this.local_page_keys.alert_update_successfully+'!')
        let listContries = await this.$store.getters['startBonus/addNewCountryCredits'];
        this.listCountryCredits = this.getNotDefaultCountries(listContries);
      }
    },
    async deleteCountryCredits(id){
      let toDelete = confirm(this.local_page_keys.alert_are_you_sure);
      if(toDelete === true){
        await this.$store.dispatch('startBonus/deleteCountryCredits', {id_country: id});
        let listContries = await this.$store.getters['startBonus/deleteCountryCredits'];
      //  this.listCountryCredits = this.getNotDefaultCountries(listContries);
        await this.getListCountry();
        await this.getListCountryCredits();
      }
    },
    async updateAll() {
      for (let item in this.updatedList) {
        let id_country = this.updatedList[item].id;
        let count_credits = this.updatedList[item].start_bonuses == null ? '' : this.updatedList[item].start_bonuses;
        let test_order = this.updatedList[item].test_order === 'true';
        await this.$store.dispatch('startBonus/addNewCountryCredits', {id_country, count_credits, test_order});
      }
      let listContries = await this.$store.getters['startBonus/addNewCountryCredits'];
      this.listCountryCredits = this.getNotDefaultCountries(listContries);
      this.listCountry = this.getDefaultListCountry(listContries);
      this.updatedList = [];
      this.updatedList.length = 0;
      this.makeVisibleButton = false;
    },
    prepareUpdateList(id, from) {
      if (from === 'radio') {
        this.radioChanged = true;
      }
      if (from === 'input' && this.listCountryCredits[id].start_bonuses !== '') {
        this.updatedList[id] = this.listCountryCredits[id];
      } else if (!this.radioChanged && from === 'input' && this.listCountryCredits[id].start_bonuses === '' && this.updatedList.indexOf(this.listCountryCredits[id]) >= 0) {
        this.updatedList.splice(this.updatedList.indexOf(this.listCountryCredits[id]), 1);
      } else {
        this.updatedList[id] = this.listCountryCredits[id];
      }
      let counter = 0;
      for (let item in this.updatedList) {
        counter++;
      }
      this.makeVisibleButton = counter > 1;
    },
    showDeleteButton(i,index) {
      if (this.wasUpdated && this.tabDataCity[i][index].id === this.updatedId && (this.tabDataCity[i][index].start_bonuses != null && this.tabDataCity[i][index].start_bonuses != '')) {
        return true;
      } else if ((!this.wasUpdated || this.tabDataCity[i][index].id !== this.updatedId) && (this.tabDataCity[i][index].start_bonuses != null && this.tabDataCity[i][index].start_bonuses != '')) {
        return true;
      }
    },
    getDefaultListCountry(list) {
      this.tabDataCity =  [[], []];
     list.forEach(item => {
       if ( item.test_order === this.defaultTestOrderValue) {
         if ( item.start_bonuses === null || item.start_bonuses === 0) {
           this.tabDataCity[1].push(item);
         } else {
           this.tabDataCity[0].push(item);
         }
       }
      });
    },
   async massUpdateStartBonuses(){
      const ids = this.tabDataCity[this.tab].map(item => item.id);
      const value = this.massUpdateStartBonusesValue;
     if ( !value || isNaN(value) || parseInt(value) < 0) {
        alert( 'The entered value must be a positive number')
      } else {
        await this.$store.dispatch('startBonus/massStartBonusUpdate', {start_bonus_value: value, ids: ids});
        alert(this.local_page_keys.alert_update_successfully+'!')
       await this.getListCountry();
       await this.getListCountryCredits();
      }
    }
  },
  async mounted() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('start_bonus'), await this.$filtergetLocalisationPage('app_config'));
    await this.getDefaultBonusSettings();
    await this.getListCountry();
    await this.getListCountryCredits();
    this.tabHeaders = {
      0: this.local_page_keys.bonus_exists,
      1: this.local_page_keys.bonus_does_not_exists
    };
  }
}
</script>

<style scoped>
  .uk-form-icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 40px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #999;
  }
  .uk-form-icon-flip {
    right: 0;
    left: auto;
  }
</style>